import React from 'react';
import { Path } from 'react-native-svg';

import { IconBase, IconProps } from './IconBase';

export const IconPaperclip: React.FunctionComponent<IconProps> = ({
  strokeWidth,
  ...props
}) => (
  <IconBase {...props}>
    <Path
      d="M21.4392 11.0581L12.2548 20.2426C10.1729 22.3245 6.79752 22.3245 4.71564 20.2426C2.63376 18.1607 2.63376 14.7854 4.71564 12.7035L13.9 3.51901C15.2877 2.13133 17.5375 2.13133 18.9252 3.51901C20.3129 4.90669 20.3129 7.15652 18.9252 8.5442L9.99564 17.4737C9.30181 18.1676 8.17689 18.1676 7.48305 17.4737C6.78922 16.7799 6.78922 15.655 7.48305 14.9611L15.6499 6.79428"
      stroke="currentColor"
      strokeWidth={strokeWidth || 2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </IconBase>
);
